import { BaseLayout, Head } from '@/components/layouts'
import { Template } from '@/core/architecture'
export * from './fragments'
import { List } from '@mui/material'

import { Maybe, PrepaidPointOrdersQuery } from '@/clients/utoniq-core/schema'
import { WalletHistoryItem } from '@/components/organisms'
import { ScrollFetcher } from '@/components/organisms/functionals'
import { useRouter, useTranslation } from '@/core'

export type State = {
  loading: boolean
  hasNextPage: boolean
  prepaidPointTransactions: Maybe<
    PrepaidPointOrdersQuery['prepaidPointTransactions']
  >
}

export type Action = {
  onFetchMore: () => Promise<void>
}

export const PrepaidPointOrdersTemplate: Template<State, Action> = ({
  state,
  onFetchMore,
}) => {
  const { t } = useTranslation('prepaidPointOrders')
  const { routerNames, routerPages } = useRouter()
  return (
    <BaseLayout
      header={{
        back: true,
        defaultBackPage: routerPages.Wallet,
        title: t('title'),
      }}
    >
      <Head title={routerNames.PointOrders} />
      <ScrollFetcher
        nodes={state.prepaidPointTransactions?.edges.map(
          (transaction, index) => (
            <WalletHistoryItem key={index} transaction={transaction.node} />
          )
        )}
        loading={state.loading}
        hasNextPage={state.hasNextPage}
        onFetchMore={onFetchMore}
        component={List}
        emptyMessage={t('prepaidPointEmptyMessage')}
      />
    </BaseLayout>
  )
}
